import React, { useEffect, useState } from 'react'
import DataTable from '../../../../Components/Others/DataTable';
import { CancelButton, CreateButton, FilterButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation } from 'react-router-dom';
import SearchBar from '../../../../Components/Utils/SearchBar';
import Dashboard from '../../Dashboard';
import UseGetData from '../../../../Components/Hooks/useFetchData';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import MoreOptions from '../../../../Components/Utils/MoreOptions';
import PremiumTable, { CopyButton } from '../../../../Components/Others/PremiumTable';
import { GetAccess, GetRole, CheckEditAction, CheckDeleteAction } from '../../../../Components/Utils/roles';
import { useDeleteData } from '../../../../Components/Hooks/useDeleteData';
import moment from 'moment';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { useFormik } from 'formik';
import * as yup from 'yup';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { NuDate } from '../../../../Components/Utils/Input';
import Importdoc from './Importdoc';
import ModalContainer from '../../../../Components/Others/ModalContainer';
import MultiEditINO from './MultiEditINO';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import NuAmount from '../../../../Components/Utils/NuAmount';
import ViewToggle from "../../../../Components/Utils/ViewToggle";

// InvoiceOutgoing Card Wrapper Component
const InvoiceOutgoingCardWrapper = ({ row, canEdit, canDelete, handleDelete, pageIndex, searchQuery }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/invoices-outgoing/" + `${row.invoiceOutId}`, setIsModalOpen);
  const formattedDate = row.date ? moment(row.date).format("DD-MMM-YYYY") : "--";
  return (
    <>
      <div className="relative border border-y-gray-200/50 border-r-gray-200/50 border-l-0 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] transition-all duration-300 rounded-2xl bg-white p-5 flex flex-col gap-4 overflow-hidden border-l-4 border-l-orange-500">
        <div className="flex justify-between items-start gap-4">
          <div className="flex flex-col">
            <div className="flex items-center gap-1.5">
              <Link
                to={`/sales/invoice_outgoing/view/${row.invoiceOutId}`}
                state={{
                  data: row,
                  pageIndex: pageIndex,
                  searchQuery: searchQuery,
                }}
                className="text-gray-800 font-bold hover:underline text-sm"
              >
                {row.ref || "N/A"}
              </Link>
              <CopyButton text={row.ref} />
            </div>
            <div className="flex items-center gap-1 mt-0.5">
              <span className="text-[10px] text-gray-500 font-bold">YPR: {row.prRef || "N/A"}</span>
              <CopyButton text={row.prRef} />
            </div>
            <span className="text-[10px] text-gray-400 font-bold mt-0.5">Customer: {row.customerName || "N/A"}</span>
          </div>
        </div>
        <div className="bg-[#FAFAFC]/60 rounded-xl p-3.5 border border-gray-100 flex justify-between text-xs">
          <div className="flex flex-col gap-0.5">
            <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Invoice Date</span>
            <span className="font-bold text-gray-700">{formattedDate}</span>
          </div>
          <div className="flex flex-col gap-0.5 items-end">
            <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Amount</span>
            <span className="font-extrabold text-gray-800">
              <NuAmount currency={row["vendorCurrency"] || row["currency"]} value={row.amount || 0} />
            </span>
          </div>
        </div>
        <div className="flex items-center justify-between border-t border-gray-100 pt-3 mt-1">
          <Link
            to={`/sales/invoice_outgoing/view/${row.invoiceOutId}`}
            state={{
              data: row,
              pageIndex: pageIndex,
              searchQuery: searchQuery,
            }}
            className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all text-xs font-semibold flex items-center gap-1.5 whitespace-nowrap"
            title="View Details"
          >
            <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
            <span className="hidden sm:inline">View Details</span>
          </Link>
          <div className="flex items-center gap-1.5">
            {CheckEditAction(row, "Invoice Outgoing", canEdit) && (
              <Link
                to={`/sales/invoice_outgoing/edit/${row.invoiceOutId}`}
                state={{ data: row, from: "/sales/invoice_outgoing", pageIndex: pageIndex, searchQuery: searchQuery }}
                className="border border-sky-100 text-[#0ea5e9] hover:bg-sky-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
                title="Edit"
              >
                <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                <span className="hidden sm:inline">Edit</span>
              </Link>
            )}
            {CheckDeleteAction(row, canDelete) && (
              <button
                onClick={() => setIsModalOpen(true)}
                className="border border-red-100 text-red-500 hover:bg-red-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
                title="Delete"
              >
                <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                <span className="hidden sm:inline">Delete</span>
              </button>
            )}
          </div>
        </div>
      </div>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.ref} will be removed from Invoice Outgoing!`}
        handleClick={handle}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

function InvoiceOutgoingIndex() {

  const location = useLocation();
  const currentPage = location.state?.currentPage
  const searchQuery = location.state?.searchQuery
  const [page, setPage] = useState(currentPage || 1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView") || 20)
  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const { value: ModeOfPayment } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'ModeOfPayment_invoicesIncoming', showFilterDialog)
  const { value: Division } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Division_invoicesIncoming', showFilterDialog)
  const { value: Status } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Status_invoicesIncoming', showFilterDialog)

  const [filterProps, setFilterProps] = useState({
    division: "",
    status: "",
    modeOfPayment: "",
    fromDate: "",
    toDate: "",
    fromDueDate: "",
    toDueDate: ""
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",

    division: "",
    status: "",
    modeOfPayment: "",
    fromDate: "",
    toDate: "",
    fromDueDate: "",
    toDueDate: ""


  });

  const clearFilter = () => {
    setParams({
      ...params, division: "",
      status: "",
      modeOfPayment: "",
      fromDate: "",
      toDate: "",
      fromDueDate: "",
      toDueDate: ""
    })
    formik.values.status = ""
    formik.values.division = ""
    formik.values.modeOfPayment = ""
    formik.values.fromDate = ""
    formik.values.toDate = ""
    formik.values.fromDueDate = ""
    formik.values.toDueDate = ""

    setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({ ...params, modeOfPayment: value.modeOfPayment, division: value.division, status: value.status, fromDate: value.fromDate, toDate: value.toDate, fromDueDate: value.fromDueDate, toDueDate: value.toDueDate })
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
        division: "",
        status: "",
        modeOfPayment: "",
        fromDate: "",
        toDate: "",
        fromDueDate: "",
        toDueDate: ""

      });
    }
  })

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch('/invoices-outgoing/', params);
  console.log(data, 'dddd');

  const defaultHeader = [
    // {
    //   title: "ID",
    //   width: "5%",
    //   field: "invoiceOutId",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Reference ",
      width: "9%",
      isLink: true,
      id: "invoiceOutId",
      link: '/sales/invoice_outgoing/view/',
      field: "ref",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "YPR",
      width: "9%",
      isLink: true,
      id: "invoiceOutId",
      link: '/sales/invoice_outgoing/view/',
      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "SO NO.",
      width: "9%",
      isLink: true,
      id: "invoiceOutId",
      link: '/sales/invoice_outgoing/view/',
      field: "coref",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Customer",
      width: "9%",
      field: "customerName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Invoice Date",
      width: "9%",
      field: "date",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Amount",
      width: "9%",
      field: "amount",
      type: "amount",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher: getData,
        id: "invoiceOutId",
        removeValue: "Invoice-Outgoing",
        url: '/invoices-outgoing/',
        moduleName: "invoice-incoming",
        from: "/sales/invoice_outgoing",
        editLink: "/sales/invoice_outgoing/edit/",
        viewLink: "/sales/invoice_outgoing/view/",
      },
    },
  ];

  let availableHeaders = [
    // {
    //   title: "ID",
    //   width: "5%",
    //   field: "invoiceOutId",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Reference ",
      width: "9%",
      isLink: true,
      id: "invoiceOutId",
      link: '/sales/invoice_outgoing/view/',
      field: "ref",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "YPR",
      width: "9%",
      isLink: true,
      id: "invoiceOutId",
      link: '/sales/invoice_outgoing/view/',
      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "SO NO.",
      width: "9%",
      isLink: true,
      id: "invoiceOutId",
      link: '/sales/invoice_outgoing/view/',
      field: "coref",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Customer",
      width: "9%",
      field: "customerName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Customer Email",
      width: "9%",
      field: "customerEmail",
      type: "email",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Invoice Date",
      width: "9%",
      field: "date",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Amount",
      width: "9%",
      field: "amount",
      type: "amount",
      textAlign: "center",
      rowAlign: "center",
    },

    // {
    //   title: "Invoice Reference",
    //   width: "9%",
    //   field: "ref",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    // {
    //   title: "Received Date",
    //   width: "9%",
    //   field: "date",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Tax",
      width: "9%",
      field: "tax",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Total Amount",
      width: "9%",
      field: "totalAmount",
      type: "amount",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Payment DueDate",
      width: "9%",
      field: "paymentDueDate",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Payment ReceivedOn",
      width: "9%",
      field: "paymentReceivedOn",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Mode Of Payment",
      width: "9%",
      field: "modeOfPayment",
      textAlign: "center",
      rowAlign: "center",
    },
    // {
    //   title: "Division",
    //   width: "9%",
    //   field: "division",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    // {
    //   title: "Comments",
    //   width: "9%",
    //   field: "comments",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },


    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher: getData,
        id: "invoiceOutId",
        removeValue: "Invoice-Outgoing",
        url: '/invoices-outgoing/',
        moduleName: "invoice-incoming",
        from: "/sales/invoice_outgoing",
        editLink: "/sales/invoice_outgoing/edit/",
        viewLink: "/sales/invoice_outgoing/view/",
      },
    },
  ];

  const [viewMode, setViewMode] = useState(localStorage.getItem("invoicesOutViewMode") || "table");
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobile ? "card" : (viewMode === "list" ? "table" : viewMode);

  const canEdit = GetAccess("invoice_out_edit") || GetRole();
  const canDelete = GetAccess("invoice_out_delete") || GetRole();
  const { handle: handleDelete } = useDeleteData(getData);

  useEffect(() => {
    localStorage.setItem("invoicesOutViewMode", viewMode);
    setParams({ ...params, page: page, per_page: pageCount })
  }, [page, pageCount, viewMode]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };


  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [listofNumbers, setListofNumbers] = useState([])
  const [fullList, setFullList] = useState([])

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some(Item => Item === value)) {
      NewId = listofNumbers.filter(Temp => Temp !== value);
      setListofNumbers(NewId)
    } else {
      setListofNumbers([...listofNumbers, value])
    }
  }

  const selectMultipleFunction = (e) => {
    console.log(e.target.checked);
    if (e.target.checked) {
      setListofNumbers(fullList)
    } else {
      setListofNumbers([])
    }

  }

  useEffect(() => {
    let tempArr = []
    data && data.forEach(i => {
      console.log("I", i?.invoiceOutId);
      tempArr.push(i?.invoiceOutId)
    });
    setFullList(tempArr)
  }, [data])

  return (
    <div className='w-full h-full px-4 py-2'>
      <div className='w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3'>
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb
            items={[
              {
                name: "Invoices-Outgoing"
              }
            ]}
          />
          <div className="flex md:hidden items-center gap-1.5 flex-wrap">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
            {GetAccess("invoice_out_create") && <Link to="/sales/invoice_outgoing/create/"><CreateButton label='Outgoing' /></Link>}
          </div>
        </div>

        <div className='w-full md:w-auto flex flex-wrap md:flex-nowrap items-center justify-between md:justify-start gap-2'>
          <div className="w-full md:w-auto flex-1 min-w-0">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1)
              }}
              value={params.search}
            />
          </div>

          <div className="hidden md:flex items-center gap-2">

            <ViewToggle
              viewMode={effectiveViewMode}
              onViewChange={(mode) => setViewMode(mode)}
              storageKey="invoicesOutViewMode"
            />
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
            {GetAccess("invoice_out_create") && <Link to="/sales/invoice_outgoing/create/"><CreateButton label='Outgoing' /></Link>}
          </div>
        </div>
      </div>

      <PremiumTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        viewMode={effectiveViewMode}
        headers={[
          { title: "Reference", width: "150px" },
          { title: "YPR", width: "150px" },
          { title: "SO No.", width: "150px" },
          { title: "Customer", width: "auto" },
          { title: "Invoice Date", width: "130px" },
          { title: "Amount", width: "140px" },
          { title: "Action", align: "center", width: "120px" }
        ]}
        renderRow={(row, idx) => {
          const formattedDate = row.date ? moment(row.date).format("DD-MMM-YYYY") : "--";
          return (
            <tr className="bg-white hover:bg-white/80 transition-colors align-middle">
              <td className="p-4 text-center align-middle border-t border-l border-gray-200/60 rounded-tl-xl rounded-bl-xl">
                <input type="checkbox" checked={listofNumbers.includes(row.invoiceOutId)} onChange={() => selectOneFunction(row.invoiceOutId)} className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer" />
              </td>
              <td className="p-4 align-middle border-t border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
                <div className="flex items-center gap-1.5">
                  <Link
                    to={`/sales/invoice_outgoing/view/${row.invoiceOutId}`}
                    state={{
                      data: row,
                      pageIndex: page,
                      searchQuery: params?.search || "",
                    }}
                    className="hover:underline text-sm font-bold text-gray-800"
                  >
                    {row.ref || "N/A"}
                  </Link>
                  <CopyButton text={row.ref} />
                </div>
              </td>
              <td className="p-4 align-middle border-t border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
                <div className="flex items-center gap-1.5">
                  <span className="text-sm font-bold text-gray-800">{row.prRef || "N/A"}</span>
                  <CopyButton text={row.prRef} />
                </div>
              </td>
              <td className="p-4 align-middle border-t border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
                <div className="flex items-center gap-1.5">
                  <span className="text-sm font-bold text-gray-800">{row.coref || "N/A"}</span>
                  <CopyButton text={row.coref} />
                </div>
              </td>
              <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600">{row.customerName || "N/A"}</td>
              <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">{formattedDate}</td>
              <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-bold text-gray-800">
                <NuAmount currency={row["vendorCurrency"] || row["currency"]} value={row.amount || 0} />
              </td>
              <td className="p-4 text-center align-middle border-t border-r border-gray-200/60 rounded-tr-xl rounded-br-xl">
                <div className="flex items-center justify-center gap-1.5">
                  <Link
                    to={`/sales/invoice_outgoing/view/${row.invoiceOutId}`}
                    state={{
                      data: row,
                      pageIndex: page,
                      searchQuery: params?.search || "",
                    }}
                    className="border border-blue-200 text-blue-600 hover:bg-blue-50 p-1.5 rounded-md transition-all"
                    title="View"
                  >
                    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                  </Link>
                  {CheckEditAction(row, "Invoice Outgoing", canEdit) && <Link to={`/sales/invoice_outgoing/edit/${row.invoiceOutId}`} state={{ data: row, from: "/sales/invoice_outgoing", pageIndex: page, searchQuery: params?.search || "" }} className="border border-sky-200 text-[#0ea5e9] hover:bg-sky-50 p-1.5 rounded-md transition-all" title="Edit">
                    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
                  </Link>}
                  {CheckDeleteAction(row, canDelete) && <button onClick={() => handleDelete("/invoices-outgoing/", row.invoiceOutId, row.ref, "Invoice Outgoing")} className="border border-red-200 text-red-500 hover:bg-red-50 p-1.5 rounded-md transition-all" title="Delete">
                    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                  </button>}
                </div>
              </td>
            </tr>)
        }}
        renderCard={(row, idx) => (
          <InvoiceOutgoingCardWrapper
            row={row}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
            pageIndex={page}
            searchQuery={params?.search || ""}
          />
        )}
        dataLoading={dataLoading}
        listofNumbers={listofNumbers}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
      />
      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-full sm:w-[520px] max-w-[95vw] max-h-[90vh] bg-white py-4 px-4 sm:px-6 rounded-xl shadow-lg overflow-y-auto">
            <h2 className="text-lg font-bold text-gray-800 mb-4">Filter Invoice-Outgoing</h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col gap-3 mb-4">
                <div>
                  <p className="py-1 text-xs font-semibold text-gray-700">Date</p>
                  <div className="flex flex-col sm:flex-row gap-2 w-full">
                    <NuDate
                      label="From"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="fromDate"
                      width="w-full"
                    />
                    <NuDate
                      label="To"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="toDate"
                      width="w-full"
                    />
                  </div>
                </div>
                <div>
                  <p className="py-1 text-xs font-semibold text-gray-700">Due Date</p>
                  <div className="flex flex-col sm:flex-row gap-2 w-full">
                    <NuDate
                      label="From"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="fromDueDate"
                      width="w-full"
                    />
                    <NuDate
                      label="To"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="toDueDate"
                      width="w-full"
                    />
                  </div>
                </div>
                <FormikSelectTwo
                  label="Mode Of Payment"
                  placeholder="Choose"
                  formik={formik}
                  Options={ModeOfPayment}
                  name="modeOfPayment"
                  width="w-full"
                />
                <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Choose"
                  Options={Status}
                  formik={formik}
                  name="status"
                  width="w-full"
                />
              </div>
              <div className="flex justify-end gap-2 pt-2 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name='Apply' />
              </div>
            </form>
          </div>
        </div>
      )}
      {showImportModal && (<Importdoc show={showImportModal} onClose={closeModal} getData={getData} />)}
      {showEdit && (<MultiEditINO data={listofNumbers} getData={getData} onClose={() => setShowEdit(false)} />)}
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => { }}
        closeModal={() => setShowDelete(false)}
      />
    </div>
  )
}
export default InvoiceOutgoingIndex